<script setup>
  import {
    computed,
    onMounted,
    onBeforeUnmount,
    ref,
    watch,
    defineAsyncComponent,
  } from 'vue';

  import { storeToRefs } from 'pinia';
  import { useRoute, RouterView } from 'vue-router';

  import MESSAGE from '@js/messages';

  import useAuthStore from '@/stores/auth';

  import CredereAlert from '@/components/Core/Alert.vue';

  const ShowroomTopBanner = defineAsyncComponent(() => import('@/components/Showroom/TopBanner.vue'));
  const ShowroomSocialBanner = defineAsyncComponent(() => import('@/components/Showroom/SocialBanner.vue'));

  const route = useRoute();

  const authStore = useAuthStore();
  const { user } = storeToRefs(authStore);

  const key = ref(0);
  watch(key, MESSAGE.SCROLL);
  function reload() { key.value += 1; }

  const { layout } = window.CREDERE;
  const _banner = computed(() => layout?._enable_top_banner);
  const _socials = computed(() => layout?._enable_social_banner);

  const NOTICE = window.CREDERE._INTERNAL.notice;
  const DESKTOP = window.CREDERE.variants?.viewport > 768;

  function resize() {
    if (/^\/preview/.test(window.location.pathname)) {
      return;
    }

    MESSAGE.RESIZE({ height: document.body.clientHeight + 1 });
  }

  const resizeObserver = new ResizeObserver(() => {
    setTimeout(() => resize(), 0);
  });

  const classes = computed(() => ({
    'credere-app': true,
    'variant--desktop': DESKTOP,
  }));

  onMounted(() => {
    resizeObserver.observe(document.body);
  });

  onBeforeUnmount(() => {
    resizeObserver.disconnect();
  });
</script>

<template>
  <div
    :class="classes"
    v-if="user.id || route.meta.public"
  >
    <showroom-top-banner v-if="_banner" />

    <credere-alert
      class="credere-app--alert"
      v-if="NOTICE"
      :color="NOTICE.color"
    >
      {{ NOTICE.message }}
    </credere-alert>

    <router-view
      :key="key"
      class="credere-route"
      @reload="reload"
    />

    <showroom-social-banner v-if="_socials" />
  </div>
</template>

<style lang="scss">
  .credere-app {
    --background-color: var(--cordel-color-constant-light);

    container-type: inline-size;
  }

  .credere-app--alert {
    --margin: 0 0 var(--cordel-spacing-blaster);
  }

  .credere-route {
    position: relative;
  }
</style>
